import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/common/Button';
import kakaoLogo from '../../../asset/img/common/kakao_sign_logo.png';
import FullButton from '../../../components/common/FullButton';
const AuthenticationSection = ({ modalOpenHandler }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('resultQuery');

  const signList = [
    { title: t('signItem1'), onClick: () => modalOpenHandler(1) },
    { title: t('signItem2'), onClick: () => modalOpenHandler(2) },
    { title: t('signItem3'), onClick: () => modalOpenHandler(3) },
    { title: t('signItem4'), onClick: () => modalOpenHandler(4), type: 'kakao' },
  ];

  return (
    <div className="signatureSection">
      <div className="displayFlex " style={{ gap: '8px' }}>
        {/* 서명하기 */}
        <FullButton
          style={{ flex: 1 }}
          title={t('signItem1')}
          icon="arrow"
          onClick={() => modalOpenHandler(1)}
        />
        {/* 문자인증 */}
        <FullButton
          style={{ flex: 1 }}
          title={t('signItem2')}
          icon="arrow"
          onClick={() => modalOpenHandler(2)}
        />
      </div>
      <div className="displayFlex" style={{ gap: '8px' }}>
        {/* 이메일인증 */}
        <FullButton
          style={{ flex: 1 }}
          title={t('signItem3')}
          icon="arrow"
          onClick={() => modalOpenHandler(3)}
        />
        {/* 간편인증 */}
        <FullButton
          style={{ flex: 1 }}
          title={t('signItem4')}
          icon="arrow"
          onClick={() => modalOpenHandler(4)}
        />
      </div>
    </div>
  );
};

export default AuthenticationSection;
